import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  LocationOnOutlined,
  HomeOutlined,
  LocalGasStationOutlined,
  BuildOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetVehicleDetailQuery } from "store/services/vehicleApi";

const VehicleInfoScreen = ({ vehicleId }) => {
  const breadcrumbs = [
    {
      title: "Vehicle Info",
    },
  ];

  // RTK Query
  const {
    data: vehicleDetail,
    isLoading: loadingVehicleDetail,
    error,
  } = useGetVehicleDetailQuery(vehicleId);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingVehicleDetail}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingVehicleDetail ? (
          <Box padding={3}>
            <Typography variant="h6">{vehicleDetail?.vehicle_type}</Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <HomeOutlined color="primary" />}
                  title="Vehicle ID"
                  subtitle={vehicleDetail?.vehicle_id}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocationOnOutlined color="primary" />}
                  title="Current Location"
                  subtitle={`Lat: ${vehicleDetail?.current_location?.lat}, Lon: ${vehicleDetail?.current_location?.lon}`}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalGasStationOutlined color="primary" />}
                  title="Fuel Level"
                  subtitle={`${vehicleDetail?.fuel_level}%`}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <BuildOutlined color="primary" />}
                  title="Next Maintenance"
                  subtitle={vehicleDetail?.next_maintenance_due}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <BuildOutlined color="primary" />}
                  title="Condition"
                  subtitle={vehicleDetail?.condition}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <BuildOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={vehicleDetail?.status === "active"} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VehicleInfoScreen;
